export const VWOConfig = {
  accountId: 532668,
  settingsTolerance: 2000,
  libraryTolerance: 2500,
  useExistingJquery: false,
  isSpa: 1,
  hideElement: 'body'
}
